'use client';

import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';
import { ClaimPageContainer } from 'structure/claim/components/ClaimPageContainer/ClaimPageContainer';

export default function TestnetClaimPage() {
  return (
    <BaseLayout>
      <ClaimPageContainer isTestnet={true} />
    </BaseLayout>
  );
}
